import { useCallback } from "react";
import * as Actions from "../actions";

export const useLivePageActions = ({ dispatch }) => {
  const setLivePageLoading = useCallback(() => dispatch(Actions.setLivePageLoading()), [dispatch]);

  return {
    setLivePageLoading,
  };
};
